/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Modal, ModalProps, Typography } from 'antd';
import { useIntl } from 'react-intl';
import { IconButtonProps } from '~components/_common/IconButton/IconButton';
import { ModalTitle } from '~components/_common/ModalTitle/ModalTitle';
import { useStyles } from '~src/hooks/useStyles';

export interface SimpleConfirmModalProps extends Partial<ModalProps> {
  isLoading?: boolean;
  onReject?: () => Promise<unknown>;
  onCancel?: () => void;
  modalTitle: string;
  modalIcon?: IconButtonProps['icon'];
}
export const SimpleConfirmModal: React.FC<SimpleConfirmModalProps> = ({
  isLoading,
  onOk,
  onCancel,
  modalTitle,
  modalIcon,
  ...modalProps
}) => {
  const intl = useIntl();
  // const styles = useStyles(styleFn);

  return (
    <Modal
      title={<ModalTitle text={modalTitle} icon={modalIcon} />}
      width={420}
      centered
      okButtonProps={{ loading: isLoading }}
      onOk={onOk}
      onCancel={onCancel}
      bodyStyle={{ padding: 0 }}
      {...modalProps}></Modal>
  );
};
